import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useLanguage } from '../../i18n/LanguageContext';
import Modal from '../../components/Modal';
import { getSettings, updateSettings, sendAnnouncement } from '../../api/AdminAPI';

const MAX_ANNOUNCEMENT_LENGTH = 500;

export default function AdminSettings() {
  const { t } = useLanguage();
  const history = useHistory();

  const [registrationOpen, setRegistrationOpen] = useState(true);
  const [closedMessage, setClosedMessage] = useState('');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [savedMessage, setSavedMessage] = useState('');

  const [announcement, setAnnouncement] = useState('');
  const [iShow, setiShow] = useState(false);
  const [sending, setSending] = useState(false);
  const [announcementError, setAnnouncementError] = useState('');
  const [announcementSent, setAnnouncementSent] = useState('');

  useEffect(() => {
    const token = localStorage.getItem('accessToken');
    (async () => {
      setLoading(true);
      const data = await getSettings(token);
      if (data.status === 'forbidden') { history.replace('/home'); return; }
      if (data.status === 'success') {
        setRegistrationOpen(data.data.registrationOpen);
        setClosedMessage(data.data.registrationClosedMessage || '');
      }
      setLoading(false);
    })();
  }, [history]);

  const save = async () => {
    const token = localStorage.getItem('accessToken');
    setSaving(true);
    setSavedMessage('');
    const data = await updateSettings(token, { registrationOpen, registrationClosedMessage: closedMessage });
    setSaving(false);
    if (data.status === 'success') {
      setSavedMessage(t('admin.settings.saved'));
    }
  };

  const confirmSendAnnouncement = async () => {
    const token = localStorage.getItem('accessToken');
    setSending(true);
    setAnnouncementError('');
    const data = await sendAnnouncement(token, announcement);
    setSending(false);
    if (data.status === 'success') {
      setiShow(false);
      setAnnouncementSent(t('admin.settings.announcementSent'));
      setAnnouncement('');
    } else {
      setAnnouncementError(data.message || t('errors.generic'));
    }
  };

  return (
    <div className="PageContainer">
      <Modal mState={{ iShow, setiShow }} buttonShow="yes">
        <p>{t('admin.settings.announcementConfirm')}</p>
        <p style={{ whiteSpace: 'pre-wrap', fontStyle: 'italic' }}>{announcement}</p>
        {announcementError && <p style={{ color: 'var(--danger-text)' }}>{announcementError}</p>}
        <div className="satirfield" style={{ float: 'left' }}>
          <button onClick={confirmSendAnnouncement} className="SendButton primaryColor" disabled={sending}>{t('common.ok')}</button>
          <button onClick={() => setiShow(false)} className="SendButton secondaryColor">{t('common.cancel')}</button>
        </div>
      </Modal>

      <div className="PageHeader glass">
        <h4>{t('admin.settings.title')}</h4>
        <aside className="descGray">{t('admin.settings.subtitle')}</aside>
      </div>
      <div className="Page glass" style={{ overflowY: 'auto' }}>
        {loading ? (
          <p style={{ padding: 20 }}>{t('common.loading')}</p>
        ) : (
          <>
            <div className="AdminSection">
              <div className="AdminToggleRow">
                <div>
                  <div>{t('admin.settings.registrationOpenLabel')}</div>
                  <div className="descGray" style={{ fontSize: 13 }}>{t('admin.settings.registrationOpenHint')}</div>
                </div>
                <button
                  className={registrationOpen ? "AdminSwitch AdminSwitchOn" : "AdminSwitch"}
                  onClick={() => setRegistrationOpen((v) => !v)}
                  aria-label={t('admin.settings.registrationOpenLabel')}
                />
              </div>

              <div className="setfield">
                {t('admin.settings.closedMessageLabel')}
                <textarea
                  className="AdminTextArea"
                  value={closedMessage}
                  placeholder={t('admin.settings.closedMessagePlaceholder')}
                  onChange={(e) => setClosedMessage(e.target.value)}
                />
              </div>

              <div className="satirfield" style={{ float: 'left', alignItems: 'center', display: 'flex', gap: 12 }}>
                <button className="SendButton primaryColor" onClick={save} disabled={saving}>{t('admin.settings.save')}</button>
                {savedMessage && <span style={{ color: 'var(--success)' }}>{savedMessage}</span>}
              </div>
            </div>

            <div className="AdminSection">
              <h5 style={{ margin: 0 }}>{t('admin.settings.announcementTitle')}</h5>
              <div className="descGray" style={{ fontSize: 13 }}>{t('admin.settings.announcementHint')}</div>
              <div className="setfield">
                <textarea
                  className="AdminTextArea"
                  value={announcement}
                  maxLength={MAX_ANNOUNCEMENT_LENGTH}
                  placeholder={t('admin.settings.announcementPlaceholder')}
                  onChange={(e) => setAnnouncement(e.target.value)}
                />
              </div>
              <div className="satirfield" style={{ float: 'left', alignItems: 'center', display: 'flex', gap: 12 }}>
                <button
                  className="SendButton primaryColor"
                  disabled={!announcement.trim()}
                  onClick={() => { setAnnouncementError(''); setAnnouncementSent(''); setiShow(true); }}
                >
                  {t('admin.settings.announcementSend')}
                </button>
                {announcementSent && <span style={{ color: 'var(--success)' }}>{announcementSent}</span>}
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
